import React, {Component} from 'react'
import PropTypes from 'prop-types'
import PrincipalDisplayLogo from './PrincipalDisplayLogo'
import './Header.scss'
import LanguageSelector from "../i18n/LanguageSelector";
import {getI18nTextWithContext, getSupportedLanguageList} from "wipi-common/src/lib/i18n";
import I18nContext from "../i18n/I18nContext";
import ThemeSelector from "../theme-selector/ThemeSelector";

export class Header extends Component {
    static contextType = I18nContext;

    chooseLanguage = (element) => {
        this.props.changeLanguage(element)
    }
    chooseTheme = (element) => {
        this.props.changeTheme(element)
    }

    render() {
        return (
            <header id="header" className="headless">
                <div className="dpag-subheader">
                    <div className="container">
                        <nav className="navbar p-1 pb-2 border-bottom" aria-label={getI18nTextWithContext(this.context,'a11y.aria.header')}>
                            <div className="container-fluid">
                                <div className="dpag-logo navbar-brand">
                                    <svg version="1.1" id="icon" xmlns="http://www.w3.org/2000/svg" width="71" height="72"
                                         viewBox="0 0 71 72" aria-label="PostIdent logo">
                                        <switch>
                                            <g id="Frame">
                                                <path id="Vector"
                                                      d="M27.5215 47.1916H33.8026L27.459 53.5681H21.1772L27.5215
                                                      47.1916ZM12.7037 53.5681H18.9869L25.3284 47.1916H19.048L12.7037
                                                      53.5681ZM41.5429 47.1916H35.2605L41.6048 53.5681H47.8865L41.5429
                                                      47.1916ZM50.0165 47.1916H43.734L50.0776 53.5681H56.3587L50.0165
                                                      47.1916ZM59.3114 21.6792C58.4198 34.6713 48.6096 46.0501 34.0543
                                                      46.0445C17.5893 46.0396 11.2239 31.8214 12.0811 21.048L16.9169
                                                      19.5199C16.1307 25.6511 18.0418 30.0731 19.3591 32.0996C17.7902
                                                      23.4261 24.3826 16.405 32.6337 16.3994C40.0557 16.3945 46.1942
                                                      21.7777 46.1647 29.5006C47.2537 26.5528 48.0118 22.065 48.1677
                                                      18.9236L59.3114 21.6792ZM41.5754 29.7732C41.5754 24.8807 37.5833
                                                      20.9151 32.6554 20.9151C27.7311 20.9151 23.7383 24.8807 23.7383
                                                      29.7732C23.7383 34.6657 27.7311 38.6313 32.6554 38.6313C37.5833
                                                      38.6313 41.5754 34.6658 41.5754 29.7732Z"
                                                />
                                            </g>
                                            <foreignObject height="93" width="90">
                                                <span className="logo-fallback"></span>
                                            </foreignObject>
                                        </switch>
                                    </svg>
                                </div>
                                <div className="dpag-product-logo flex-grow-1" data-test-id="e00c1de5">
                                    <span id="post">POST</span><span id="ident">IDENT</span>
                                </div>
                                <div className="dpag-principal-logo d-none d-sm-block d-sm-none d-md-block">
                                <PrincipalDisplayLogo
                                    src={this.props.principalDisplayLogo}
                                    alt={this.props.principalDisplayName}/>
                                </div>
                                <div className="some-padding">
                                    <ThemeSelector
                                    changeTheme={this.chooseTheme}/>
                                </div>
                                {!this.props.signingWorkflow &&
                                    <div className="dpag-language">
                                        <LanguageSelector
                                            languageList={getSupportedLanguageList()}
                                            changeLanguage={this.chooseLanguage}
                                            selectedLanguage={this.props.selectedLanguage}/>
                                    </div>
                                }
                            </div>
                        </nav>
                    </div>
                </div>
            </header>
        )
    }
}

Header.propTypes = {
    changeLanguage: PropTypes.func.isRequired,
    changeTheme: PropTypes.func,
    selectedLanguage: PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
    }).isRequired,
    signingWorkflow: PropTypes.bool,
    principalDisplayLogo: PropTypes.string,
    principalDisplayName: PropTypes.string

}